import { BillingStatus, Currency, PricingPlan } from '@css-xp/graphtypes/src/generated-types-new';
import { CCPPricing } from '@atlassian/cssxp-typescommon';

export const formatPricingPlansForStore = ({
  availablePricingPlans,
}: {
  availablePricingPlans?: (PricingPlan | null)[] | null;
}) => {
  const activeDefaultPricingPlans = availablePricingPlans?.filter(
    (pricingPlan) => pricingPlan?.pricingPlanType === 'DEFAULT_PRICING' && pricingPlan?.status === BillingStatus.ACTIVE
  ) as PricingPlan[];

  const activeDefaultUSDPricingPlans = activeDefaultPricingPlans?.filter(
    (pricingPlan) => pricingPlan?.currency === Currency.USD
  ) as PricingPlan[];
  // the currency of the pricing plan can be null or USD for default pricing plan
  const defaultPricingPlan = activeDefaultPricingPlans?.find(
    (pricingPlan) =>
      pricingPlan?.type === CCPPricing.COMMERCIAL &&
      (!pricingPlan?.currency || pricingPlan?.currency?.toUpperCase() === Currency.USD)
  );

  // This is to map the default pricing plan to the pricing type like ACADEMIC, COMMERCIAL, etc.
  const USDPricingPlanEligibility = activeDefaultUSDPricingPlans?.reduce(
    (acc: Record<string, string>, plan: { type: string; id: string }) => {
      return {
        ...acc,
        [plan.type]: plan.id,
      };
    },
    {}
  );

  const pricingPlans = activeDefaultPricingPlans?.map((plan) => ({
    currency: plan.currency || Currency.USD,
    type: plan.type,
    id: plan.id,
  }));

  return {
    pricingPlans,
    defaultPricingPlan,
    USDPricingPlanEligibility,
  };
};
